export const CM_TROPHY_STAGE_BY_LEVEL = { 9: 'nyay_panchayat', 10: 'vidhan_sabha', 11: 'sansad', 12: 'state' };

// Multiple accounts can carry the "state" level (full visibility), but only this
// designated "Sub Admin" reviewer account may approve/reject applications.
export const DESIGNATED_REVIEWER_EMAIL = 'subadmin@khelouk.in';

// Any application, regardless of workflow stage, may be decided by the designated reviewer
// — the nyay_panchayat/vidhan_sabha/sansad forwarding pipeline isn't in active use.
export const canDecideCmTrophy = (userLevel, userEmail) =>
  CM_TROPHY_STAGE_BY_LEVEL[userLevel] === 'state' &&
  userEmail === DESIGNATED_REVIEWER_EMAIL;
